/*
 * @author        joseph.murphy@zumper.com
 * @copyright     Copyright (c) 2023, Zumper
 * @description   nr file ported over to nr-utils
 */

export const Setting = {
  API_URL: 'API_URL',
  APP_HOSTNAME: 'APP_HOSTNAME',
  DEBUG: 'DEBUG',
  GIT_SHA: 'GIT_SHA',
  IGNORE_CRITICAL_STYLES: 'IGNORE_CRITICAL_STYLES',
  IMAGE_STATIC_CDN_URL: 'IMAGE_STATIC_CDN_URL',
  INTERNAL_VIDEO_CDN_URL: 'INTERNAL_VIDEO_CDN_URL',
  IS_ZUMPER_RENTALS: 'IS_ZUMPER_RENTALS',
  MEDIA_CDN_URL: 'MEDIA_CDN_URL',
  SERVER_BASIC_AUTH_TOKEN: 'SERVER_BASIC_AUTH_TOKEN',
  STATIC_CDN_URL: 'STATIC_CDN_URL',
  STORAGE_PREFIX: 'STORAGE_PREFIX',
}
